import React from 'react';
import PropTypes from 'prop-types';
import { RichText } from 'prismic-reactjs';

export default function StatsSlice(props) {

    const {
        title,
        description,
        background,
        stats
    } = props.stats;

    const style = {
        backgroundImage: `url(${background})`
    }

    return (
        <section className="stats-section">
            <div className="stats-section__banner" style={style}></div>
            <div className="dark-overlay dark-overlay-darker"></div>
                {stats && stats.length > 0 && (
                <div className="stats-section__content container">
                    <div className="banner-content">
                        <div className="content-container">
                            {title && <h2 className="h2 title">{title}</h2>}
                            {description && description.length > 0 && RichText.render(description)}
                        </div>
                    </div>
                    <ul className="stats-list">
                        {stats.map((singleStat, index) => (
                        <li className="stats-list__item" key={index}>
                            <h3 className="h3 title">{singleStat.title}</h3>
                            <div className="description">
                                {singleStat.description && singleStat.description.length > 0 && RichText.render(singleStat.description)}
                            </div>
                        </li>
                        ))}
                    </ul>
                </div>
                )}
        </section>
    )
}

StatsSlice.propTypes = {
    stats: PropTypes.shape({
        title: PropTypes.string,
        type: PropTypes.string,
        description: PropTypes.arrayOf(PropTypes.object),
        background: PropTypes.string,
        stats: PropTypes.arrayOf(PropTypes.shape({
            title: PropTypes.string,
            description: PropTypes.arrayOf(PropTypes.object)
        }))
    })
}



// WEBPACK FOOTER //
// src/client/components/slices/StatsSlice.js